export default function initAthletePopup($) {
  $(document).on('click', '.show-bio', function(e) {
    e.preventDefault();
    var person_id = $(this).attr('data-person');

    $('#pow-modal #modal-content').html($('body').find('.person-modal-content[data-person="' + person_id + '"]').clone());
    $('#pow-modal').show();
  });

  $(document).on('click', '#pow-modal .modal-close', function(e) {
    e.preventDefault();

    $('#pow-modal #modal-content').empty();
    $('#pow-modal').hide();
  });

  $(document).on('keyup', function(e) {
    if ($('#pow-modal').is(':visible') && e.key === "Escape") {
      $('#pow-modal #modal-content').empty();
      $('#pow-modal').hide();
    }
  });

  $(document).ready(function() {
    if( window.location.hash && $('[data-person="' + location.hash.substr(1) + '"]').length ) {
      var person_id = location.hash.substr(1);

      $('#pow-modal #modal-content').html($('body').find('.person-modal-content[data-person="' + person_id + '"]').clone());
      $('#pow-modal').show();
    }
  });
}
